import { languageCodes, type LanguageCode } from 'shared/library/i18n/languages';

function getPathname(value: string) {
  try {
    return new URL(value, 'https://getapet.com').pathname;
  } catch {
    return value.split('?')[0]?.split('#')[0] ?? '/';
  }
}

function normalizeNextDataPath(pathname: string) {
  const match = pathname.match(/^\/_next\/data\/[^/]+\/(.+)\.json$/);

  if (!match) {
    return pathname;
  }

  return `/${match[1]}`.replace(/\/index$/, '') || '/';
}

export function getLanguageCodeFromPath(value?: string | null): LanguageCode | null {
  if (!value) {
    return null;
  }

  const pathname = normalizeNextDataPath(getPathname(value));
  const [, firstSegment] = pathname.split('/');

  if (firstSegment && languageCodes.includes(firstSegment as LanguageCode)) {
    return firstSegment as LanguageCode;
  }

  return null;
}
